import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const MusicaPage = lazy(() => import('../pages/musica/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/musica',
    element: <MusicaPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;